export const resolveReconnectCompletionState = (payload = {}) => {
  const recoverySucceeded = payload?.recoverySucceeded !== false;

  return {
    isDisconnected: false,
    isReconnecting: false,
    isReconnected: recoverySucceeded,
    showNotification: recoverySucceeded,
  };
};

export const resolveDisconnectedState = ({ isDisconnected = true } = {}) => ({
  isDisconnected,
  isReconnecting: false,
  isReconnected: false,
  showNotification: true,
});
